export const COLLECTION_CLIP_CANDIDATE_SOURCES = ['match', 'extract', 'grammar'] as const;
